import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import { Box, Backdrop, Hidden } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Icon from "@mui/material/Icon";
import makeStyles from "@mui/styles/makeStyles";
import { history } from "../../utils/history";
const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
	width: drawerWidth,
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	backgroundColor: theme.palette.text.disabled,
	overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
	transition: theme.transitions.create("width", {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	backgroundColor: theme.palette.text.disabled,
	overflowX: "hidden",
	width: `calc(${theme.spacing(6)} )`,
	[theme.breakpoints.up("sm")]: {
		width: `calc(${theme.spacing(7)})`,
	},
});

const DrawerHeader = styled("div")(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "flex-end",
	padding: theme.spacing(0, 1),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
	shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
	width: drawerWidth,

	flexShrink: 0,
	whiteSpace: "nowrap",
	boxSizing: "border-box",
	...(open && {
		...openedMixin(theme),
		"& .MuiDrawer-paper": openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		"& .MuiDrawer-paper": closedMixin(theme),
	}),
}));
const useStyles = makeStyles((theme: Theme) => ({
	root: {
		width: "100%",
		maxWidth: 360,
		display: "flex",
		marginTop: -50,
	},

	menuButton: {
		marginRight: 36,
	},
	hide: {
		display: "none",
	},
	drawer: {
		width: drawerWidth,
		zIndex: 800,
		flexShrink: 0,
		whiteSpace: "nowrap",
		display: "none",
		[theme.breakpoints.up("md")]: {
			display: "flex",
		},
	},
	drawerOpen: {
		width: drawerWidth,
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
		paddingTop: "55px",
		backgroundColor: "#818285",
	},
	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		overflowX: "hidden",
		width: theme.spacing(7 + 1),
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(7 + 1),
		},
		paddingTop: "55px",
		background: "#818285",
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
		paddingTop: 60,
		// necessary for content to be below app bar
		...theme.mixins.toolbar,
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3),
	},
	selectedColor: {
		color: theme.palette.secondary.main,
	},
	nested: {
		paddingLeft: theme.spacing(8),
		"&:hover": {
			backgroundColor: "#505050",
		},
	},
	links: {
		textDecoration: "none",
		color: theme.palette.secondary.main,
		"&:hover": {
			backgroundColor: "#505050",
		},
	},
	selected: {
		color: theme.palette.secondary.main,
	},
	padding: {
		padding: "8px",
		color: theme.palette.secondary.main,
	},
}));
function SideBar(props: any) {
	const classes = useStyles();
	let path: any = window.location.pathname.split("/")[2];
	const [open, setOpen] = React.useState(false);
	const [openSettings, setOpenSettings] = React.useState<boolean>(false);
	const [selectedIndex, setSelectedIndex] = React.useState<any>(path);
	const items = [
		{
			icon: "dashboard_icon",
			text: "Dashboard",
			link: `/memberfitness/dashboard`,
		},
		{
			icon: "person",
			text: "Profile",
			link: `/memberfitness/profile`,
		},
		// {
		// 	icon: "event",
		// 	text: "Schedule",
		// 	link: `/memberfitness/schedule`,
		// },
		// {
		// 	icon: "post_add_icon",
		// 	text: "Enroll",
		// 	link: `/devclub/enroll`,
		// },
		{
			icon: "shopping_cart",
			text: "Marketplace",
			link: `/memberfitness/marketplace`,
		},
	];
	React.useEffect(() => {
		if (path === "signin") {
			path = "profile";
		}
		setSelectedIndex(path);
	}, [path]);

	const handleDrawerToggle = () => {
		if (open) {
			setOpen(false);
			setOpenSettings(false);
		} else {
			setOpen(true);
		}
	};
	// const handleSettingsClick = () => {
	// 	setOpenSettings(!openSettings);
	// 	if (!openSettings) {
	// 		setOpen(true);
	// 	}
	// };
	const handleSignOut = () => {
		setOpen(false);
		props.onSignOut()
		history.push('/memberfitness/signin')
	};
	const handleMenuClick = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
		index: number
	) => {
		setSelectedIndex(index);
		setOpenSettings(false);
		setOpen(false);
	};
	let active = useSelector((state: any) => state.auth.active)
	return (
		<Hidden mdDown>
			<Box sx={{ display: "flex" }}>
				{active &&
					<>
						<CssBaseline />
						<Backdrop
							open={open}
							style={{ backgroundColor: "rgba(0,0,0,.6)", zIndex: 100 }}
							onClick={handleDrawerToggle}
						/>
						<Drawer variant="permanent" open={open}>
							<DrawerHeader sx={{ pt: 8, pb: 1 }}>
								<IconButton sx={{ p: 1 }} onClick={handleDrawerToggle}>
									{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
								</IconButton>
							</DrawerHeader>
							<Divider />
							<List component="div" disablePadding>
								{items.map((item, index) => {
									return (
										<Link key={index} className={classes.links} to={item.link}>
											<ListItem
												selected={selectedIndex === item.text.toLowerCase()}
												onClick={(event) => handleMenuClick(event, index)}
												button
												className={classes.links}
											>
												<ListItemIcon>
													{/* <StyledBadge badgeContent={3} color="secondary"> */}
													<Icon>{item.icon}</Icon>
													{/* </StyledBadge> */}
												</ListItemIcon>
												<ListItemText primary={item.text} />
											</ListItem>
										</Link>
									);
								})}
								<Link
									className={classes.links}
									to={`/memberfitness/signin`}
								>
									<ListItem
										selected={selectedIndex === 11}
										className={classes.links}
										onClick={handleSignOut}
										button
									>
										{" "}
										<ListItemIcon>
											<ExitToAppIcon />
										</ListItemIcon>
										<ListItemText primary="Sign Out" />
									</ListItem>
								</Link>
								{/* <ListItem
									className={classes.links}
									button
									onClick={handleSettingsClick}
								>
									<ListItemIcon>
										<SettingsIcon />
									</ListItemIcon>
									<ListItemText primary={"Settings"} />
									{openSettings ? <ExpandLessIcon /> : <ExpandMoreIcon />}
								</ListItem>
								<Collapse in={openSettings} timeout="auto" unmountOnExit>
									<Link className={classes.links} to="/settings/FAQs">
										<ListItem
											selected={selectedIndex === 8}
											onClick={(event) => handleMenuClick(event, 8)}
											button
											className={classes.nested}
										>
											<ListItemText primary="FAQs" />
										</ListItem>
									</Link>
									<Link className={classes.links} to="/settings/contact">
										<ListItem
											selected={selectedIndex === 9}
											onClick={(event) => handleMenuClick(event, 9)}
											button
											className={classes.nested}
										>
											<ListItemText primary="Contact" />
										</ListItem>
									</Link>
									<Link className={classes.links} to="/settings/contact">
										<ListItem
											selected={selectedIndex === 10}
											onClick={(event) => handleMenuClick(event, 10)}
											button
											className={classes.nested}
										>
											<ListItemText primary="Help" />
										</ListItem>
									</Link>
									<Link
										className={classes.links}
										to={`/${props.userConfig?.businessAlias}/signin`}
									>
										<ListItem
											selected={selectedIndex === 11}
											onClick={handleSignOut}
											button
											className={classes.nested}
										>
											<ListItemText primary="Sign Out" />
										</ListItem>
									</Link>
								</Collapse> */}
							</List>
						</Drawer></>}
			</Box>
			)
		</Hidden>
	);
}
const mapStateToProps = (state: any) => {
	return {
		user: state.auth.currentUser,
		errors: state.auth.errors,
		userConfig: state.auth.userConfig,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {
		onSignOut: () => dispatch({ type: "FAKE_LOGOUT" }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
